import { useMemo } from 'react';

import type { WalletInterface } from '@api';

import { useWalletOptions } from '@shared/common/components/AuthModal/useWalletOptions';
import { useFeatureToggles } from '@shared/hooks/useFeatureToggles';

import { getConnectedWallet } from './getConnectedWallet';
import { WALLET_CONNECT_TYPES, WalletConnectType } from './walletsConfig';

export const useAvailableConnectTypes = (wallets: WalletInterface[]) => {
  const featureToggles = useFeatureToggles();
  const options = useWalletOptions();
  const isEvmConnected = !!getConnectedWallet(wallets, WalletConnectType.EVM);

  const connectTypes = useMemo(() => {
    return WALLET_CONNECT_TYPES.filter((type) => {
      if (type === WalletConnectType.TON) {
        return !!featureToggles.tonConnect;
      }

      if (type === WalletConnectType.PASSKEY && isEvmConnected) {
        return false;
      }

      if (options[type]?.hide) {
        return false;
      }

      return true;
    });
  }, [featureToggles.tonConnect, options, isEvmConnected]);

  return { connectTypes };
};
